<template>
<v-container style="height:100%;">
  <div style="text-align:center">

    <pre style="position:relative;left:50%;transform: translateX(-50%);text-align:left;display: table;font-family:'Ubuntu Mono'!important;" :class="$vuetify.breakpoint.smAndDown?'title':'headline'"> _________________________
< SORRY,                  >
< We can't find this page >
 -------------------------
   \   ^__^
    \  (oo)\_______
       (__)\       )\/\
           ||----w |
           ||     ||</pre>
    <br><br><br><hr>
    <span class="myemail">&#64;</span>
  </div>
</v-container>
</template>

<script>
export default {
  name: "error-page"
}
</script>



// WEBPACK FOOTER //
// src/content/error-page.vue